module.exports = __webpack_public_path__ + "static/media/trade-mission.df2851fe.png";